module.exports = __webpack_public_path__ + "static/cafeblack-5db82225bb15a8aff545a9bf19243072.jpg";